import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService, EmailCategory } from 'src/app/services/config.service';
import { UserService } from 'src/app/services/user.service';
import { GetUserProfileResponse, User } from 'src/app/models/user.model';
import { forkJoin, Observable } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { NgForm } from '@angular/forms';
import { ScrBaseComponent } from '../../../base.component';
import { TableColumn } from 'src/app/models/table-columns';
import { ScrAuthorizationService } from 'src/app/services/authorization.service';
import { AdminInfo, AdminInfoResponse } from 'src/app/models/account.model';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { ShortCodesRole, ShortCodesRoleLabels } from '../../../../models/constants';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html'
})
export class MyProfileComponent extends ScrBaseComponent implements OnInit {
  @ViewChild('myProfileForm', { static: false }) myProfileForm!: NgForm;

  public emailCategories: EmailCategory[] = [];
  public userProfile: User = {} as User;
  public emailCategoryArray: string[] = [];
  public publicEmailDomains: string[] = [];
  public roleLabels = '';

  public tableColumn: TableColumn[] = [
    { field: 'name', width: '5' },
    { field: 'phone', width: '5' },
    { field: 'email', width: '7' },
  ];
  public adminInfo?: AdminInfo[];

  constructor(private configService: ConfigService, private userService: UserService, private accountService: AccountService, private authorizationService: ScrAuthorizationService) { super(); }

  ngOnInit(): void {
    this.configService.getConfig().subscribe(cfg => {
      this.publicEmailDomains = cfg.publicEmailDomains;
    });

    this.localizeTableColumns(this.tableColumn);
    const sources: Observable<EmailCategory[] | AdminInfoResponse | GetUserProfileResponse>[] = [
      this.configService.getEmailCategories(),
      this.userService.getUserProfile()
    ];
    // if user is registrant and not registrant admin, then also fetch the acccount admin info.
    this.authorizationService.getAuthorizedGroups().subscribe(grps => {
      if ((grps.includes(ShortCodesRole.Registrant) && !grps.includes(ShortCodesRole.RegistrantAdmin)) ||
        (grps.includes(ShortCodesRole.CarrierRegistrant) && !grps.includes(ShortCodesRole.Carrier))) {
        sources.push(this.accountService.getAccountAdmins());
      }

      forkJoin(sources).subscribe(rsp => {
        this.emailCategories = (rsp[0] as EmailCategory[]).filter(cat => {
          if ((cat.emailCategoryId === 6 || cat.emailCategoryId === 7)  && (grps.includes(ShortCodesRole.CarrierRegistrant) || (grps.includes(ShortCodesRole.Carrier)))) {
            return false;
          }
          return true;
        });

        const u = (rsp[1] as GetUserProfileResponse).user;

        // make a copy of the user profile so that values are not
        // updated until user presses submit.
        this.userProfile = Object.assign({}, u);
        if (rsp.length > 2) {
          this.adminInfo = (rsp[2] as AdminInfoResponse).accountAdmins;
        }
        this.userProfile.country = this.userProfile.country?.toLowerCase();
        this.emailCategoryArray = this.userProfile.emailCategoryList;

        this.roleLabels = this.userProfile.roleList.map(r => {
          const idx = Object.keys(ShortCodesRole).indexOf(r);
          return Object.values(ShortCodesRoleLabels)[idx];
        }).join(', ');
      },
        error => {
          this.log.error(error);
        });
    });
  }

  // Refactor nested subscriptions
  copyAccountInfo() {
    this.accountService.getAccount().subscribe(rsp => {
      this.userProfile.country = rsp.account.country ? rsp.account.country : '';
      this.userProfile.address1 = rsp.account.address1 ? rsp.account.address1 : '';
      this.userProfile.address2 = rsp.account.address2 ? rsp.account.address2 : '';
      this.userProfile.city = rsp.account.city ? rsp.account.city : '';
      // Wait for country. Hacky Fix.
      setTimeout(() => {
        this.userProfile.state = rsp.account.state ? rsp.account.state : '';
        this.userProfile.zip = rsp.account.zip ? rsp.account.zip : '';
      }, 100);
    });
  }

  submit() {
    this.clearMessages();

    if ((this.userProfile.email !== this.userProfile.confirmEmail) && this.myProfileForm?.controls.email.dirty) {
      const elmnt = document.getElementById('confirmEmailLabel');
      elmnt?.scrollIntoView();
      return;
    }

    if (this.myProfileForm?.invalid) {
      this.scrollToFirstError();
      return;
    }

    this.userProfile.emailCategoryList = this.emailCategoryArray;

    const userProfile = { ...this.userProfile };
    delete userProfile.confirmEmail;

    this.observe(this.userService.updateUserProfile(userProfile), rsp => {
      if (rsp.updateUserResponse?.emailChanged) {
        this.displayLocalizedSuccess('scr.emailupdated.success', undefined, 'scr.success.title', 10_000, true, 'message');
      } else if (rsp.emailExists) {
        this.jumpToTop();
        this.processScrErrorResponse(rsp);
      } else {
        this.jumpToTop();
        this.displaySuccess(rsp.messages[0].message);
      }
      this.myProfileForm.form.controls.email.markAsPristine();
      this.userProfile.confirmEmail = '';
      return false;
    });
  }

  handleEnter(event : Event){
    handleEnterKeyPress(event);
  }
}
